const sleep = (ms: number) => {
    return new Promise((resolve) => setTimeout(resolve, ms));
};

export const importRetry = async (
    importFn: () => Promise<{
        default: React.ComponentType<any>;
    }>,
    retries = 2,
    interval = 1000
): Promise<{
    default: React.ComponentType<any>;
}> => {
    try {
        return await importFn();
    } catch (error: any) {
        if (retries) {
            await sleep(interval);
            return importRetry(importFn, retries - 1, interval);
        } else {
            throw new Error(error);
        }
    }
};
